// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button--Fe8aCvnf{background:rgba(255,255,255,0.5);box-shadow:0px 4px 8px 0px rgba(0,0,0,0.06);border:1px solid rgba(255,255,255,0.3);-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);display:flex;align-items:center;gap:5px;height:40px;border-radius:20px;padding:0 16px;color:#262626;cursor:pointer;margin:0 auto}.button--Fe8aCvnf:focus{outline:none}.button--Fe8aCvnf[disabled]{color:rgba(0,0,0,0.45);cursor:default}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `button--Fe8aCvnf`
};
export default ___CSS_LOADER_EXPORT___;
